import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { take, exhaustMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AddProjectsService {
  constructor(private http: HttpClient, private authService: AuthService ) { }

  postProject(body: any){
    return this.http.post(`${environment.local}projects/add-project`, body)
  }
  getProject(page: number){
    return this.http.post(`${environment.local}projects/get-project`, page)
  }
  getById(id: string){
    return this.http.get(`${environment.local}projects/project/${id}`)
  }
  deleteProject(id: string){
    return this.http.delete(`${environment.express}/projects/project-delete/${id}`)
  }
  editProject(id: string,body: any){
    return this.http.put(`${environment.express}projects/project-edit/${id}`, body)
  }

  fetchDetail(id: any){
    this.authService.user.pipe(take(1), exhaustMap(user => {
      return this.http.get(`${environment.local}projects/project/${id}`, {
        params: new HttpParams().set('Bearer Token', user.token)
      })
    }))
  }
}
